// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';

type UserState = {
  loggedInUser?: LoggedInUser;
  login: (id?: string) => void;
  logout: () => Promise<void>;
  isSelfSignedToken: () => boolean;
  signoutOnUnauthorized: (err: unknown) => void | undefined;
};

export type LoggedInUser = {
  userId: string;
  userAccessToken: string;
};

export const UserContext = React.createContext<UserState | undefined>(undefined);

export const useUserState: () => UserState = () => {
  const user = useContext<UserState | undefined>(UserContext);
  if (!user) {
    throw new Error('User context not initialized');
  }
  return user;
};

export const useLoggedInUser: () => LoggedInUser = () => {
  const userState = useUserState();
  if (userState.loggedInUser) {
    return userState.loggedInUser;
  }
  throw new Error('User not logged in, check if you guarded this by authcheck');
};
